
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7pHzy", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $565caacea51051c8$export$6503ec6e8aabbaf; }, function (v) { return $565caacea51051c8$export$6503ec6e8aabbaf = v; });
var $565caacea51051c8$export$6503ec6e8aabbaf;
var $565caacea51051c8$export$f7ad0328861e2f03;
"use strict";
var $565caacea51051c8$var$mapping = new Map();
function $565caacea51051c8$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$565caacea51051c8$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $565caacea51051c8$var$resolve(id) {
    var resolved = $565caacea51051c8$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$565caacea51051c8$export$6503ec6e8aabbaf = $565caacea51051c8$var$register;
$565caacea51051c8$export$f7ad0328861e2f03 = $565caacea51051c8$var$resolve;

});

var $b21e188821e5d417$exports = {};

(parcelRequire("7pHzy")).register(new URL("", import.meta.url).toString(), JSON.parse('["50iJS","index.27009023.js","kIVNR","carLogo.e02ef99a.svg"]'));


//# sourceMappingURL=index.runtime.b20f5796.js.map
